// export const API_URL = "http://localhost:5000/api";
export const API_URL = "https://api.terravivagrants.info/api";

export const WEB_URL = "https://admin.terravivagrants.info"
// export const WEB_URL = "http://localhost:3000"
